/**
 * Pushes data to the data layer
 * @param {Object} data - The data to be pushed to the data layer
 * @returns {Promise} A Promise that resolves after pushing the data to the data layer
 */
function pushDataLayer(data) {
    return new Promise(function (resolve) {
        if (data && data.visitName) {
            window.dataLayer.push(data);
        }
        resolve();
    });
}

/**
 * Handles the click event for reservation button
 * @returns {void}
 */
function handleReservationClick() {
    $(".js-track-visit .js-active-button a").on("click", function (e) {
        e.preventDefault();

        var redirectionUrl = $(this).attr("href");
        var visitName = $(this).closest(".js-track-visit").data("en") || "";

        pushDataLayer({
            event: "visitReservationClick",
            visitName: visitName,
        }).then(function () {
            window.location.href = redirectionUrl;
        });
    });
}

export default () => {
    handleReservationClick();
};
